module.exports = __webpack_public_path__ + "static/media/KolabUNUDdanIYSA.80b758e1.WebP";